import React from 'react';
import { Link } from 'react-router-dom';
import { LegalLayout, OPERATOR } from './LegalLayout';

export default function LegalPrivacy() {
    return (
        <LegalLayout title="Politica de Confidențialitate" lastUpdated="1 iunie 2026">
            <p>
                Această politică explică ce date personale colectează <strong>{OPERATOR.legal_name}</strong> prin
                platforma <strong>{OPERATOR.platform}</strong>, cum le folosim, cu cine le partajăm și ce drepturi ai conform
                Regulamentului General privind Protecția Datelor (GDPR — Regulamentul UE 2016/679).
            </p>

            <h2>1. Cine suntem (Operatorul de date)</h2>
            <ul>
                <li><strong>Denumire:</strong> {OPERATOR.legal_name}</li>
                <li><strong>CUI:</strong> {OPERATOR.cui}</li>
                <li><strong>Nr. Registrul Comerțului:</strong> {OPERATOR.reg_com}</li>
                <li><strong>Sediu social:</strong> {OPERATOR.address}</li>
                <li><strong>Email contact:</strong> <a href={`mailto:${OPERATOR.email}`}>{OPERATOR.email}</a></li>
            </ul>

            <h2>2. Ce date prelucrăm</h2>
            <p>Prelucrăm DOAR datele necesare pentru funcționarea serviciului:</p>
            <h3>2.1 Date despre contul tău (administrator restaurant)</h3>
            <ul>
                <li>Nume și prenume</li>
                <li>Adresă email (pentru autentificare, OTP, facturi, notificări)</li>
                <li>Număr de telefon (pentru autentificare în 2 pași prin WhatsApp și contact urgent)</li>
                <li>Parolă (stocată criptat ireversibil cu bcrypt — nu o putem citi)</li>
                <li>Adresă IP și user-agent (pentru securitate, anti-bruteforce)</li>
            </ul>
            <h3>2.2 Date despre restaurant (pentru facturare)</h3>
            <ul>
                <li>Denumire legală, CUI/CIF, Nr. Registrul Comerțului</li>
                <li>Adresă sediu social (județ, oraș, stradă, cod poștal)</li>
                <li>IBAN (opțional)</li>
                <li>Email facturare (opțional, dacă diferă de email-ul de cont)</li>
            </ul>
            <h3>2.3 Date operaționale</h3>
            <ul>
                <li>Meniul restaurantului (categorii, produse, prețuri, poze)</li>
                <li>Mese, comenzi efectuate, plăți, statistici interne</li>
                <li>Mesaje transmise prin platformă (chemare ospătar, cerere notă)</li>
            </ul>
            <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem' }}>
                <strong>Datele clienților finali</strong> (cei care scanează QR-ul în restaurant și fac comandă):
                NU colectăm date de identificare. Comenzile sunt asociate doar cu numărul mesei.
            </p>

            <h2>3. De ce prelucrăm aceste date (Scop și temei juridic)</h2>
            <table style={{ width: '100%', borderCollapse: 'collapse', margin: '1rem 0' }}>
                <thead>
                    <tr style={{ background: 'var(--surface-2)' }}>
                        <th style={{ padding: 8, textAlign: 'left' }}>Scop</th>
                        <th style={{ padding: 8, textAlign: 'left' }}>Temei (Art. 6 GDPR)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr><td style={{ padding: 8 }}>Furnizare serviciu (cont, meniu, comenzi)</td><td style={{ padding: 8 }}>Executare contract</td></tr>
                    <tr><td style={{ padding: 8 }}>Autentificare și securitate</td><td style={{ padding: 8 }}>Interes legitim</td></tr>
                    <tr><td style={{ padding: 8 }}>Facturare abonament</td><td style={{ padding: 8 }}>Obligație legală (Cod fiscal)</td></tr>
                    <tr><td style={{ padding: 8 }}>Comunicări service (email/WhatsApp)</td><td style={{ padding: 8 }}>Executare contract</td></tr>
                    <tr><td style={{ padding: 8 }}>Răspuns la solicitări de suport</td><td style={{ padding: 8 }}>Interes legitim</td></tr>
                </tbody>
            </table>

            <h2>4. Cât timp păstrăm datele</h2>
            <ul>
                <li><strong>Date cont și restaurant:</strong> cât timp contul e activ + 30 zile după ștergere</li>
                <li><strong>Facturi și date contabile:</strong> 10 ani (obligație legală fiscală)</li>
                <li><strong>Loguri securitate (IP, încercări login):</strong> 90 zile</li>
                <li><strong>Comenzi închise (plătite/anulate):</strong> 5 ani (audit + statistici agregate)</li>
            </ul>

            <h2>5. Cu cine partajăm datele (Procesatori — Subprocessors)</h2>
            <p>
                Folosim furnizori externi de încredere, fiecare cu propriul angajament de protecție a datelor:
            </p>
            <ul>
                <li><strong>MongoDB Atlas</strong> (MongoDB Inc., EU) — bază de date cloud (Frankfurt)</li>
                <li><strong>Render</strong> (Render Services Inc., US) — hosting backend</li>
                <li><strong>Cyberfolks</strong> (CyberFolks SRL, Romania) — hosting frontend</li>
                <li><strong>SmartBill</strong> (Intelligent IT SRL, Romania) — emitere facturi</li>
                <li><strong>Twilio</strong> (Twilio Inc., US/EU) — coduri OTP WhatsApp</li>
                <li><strong>Mail Server (mail.clickmeniu.ro)</strong> — trimitere email-uri tranzacționale</li>
                <li><strong>Revolut Merchant</strong> (Revolut Ltd., UK/EU) — procesare plăți card</li>
                <li><strong>Supabase</strong> (Supabase Inc., EU) — stocare poze meniu (opțional)</li>
                <li><strong>Google Analytics 4</strong> (Google Ireland Ltd., EU/US) — statistici trafic site (vizite, pagini, sursă). IP-ul vizitatorilor este anonimizat automat. Nu folosim Google Ads / publicitate.</li>
                <li><strong>ANAF</strong> — interogare publică registru CUI (doar la înregistrare)</li>
            </ul>
            <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem' }}>
                NU vindem și NU închiriem datele tale către terți pentru marketing. Procesatorii de mai sus
                primesc doar datele strict necesare pentru funcția lor.
            </p>

            <h2>6. Drepturile tale GDPR</h2>
            <ul>
                <li><strong>Dreptul de acces</strong> — să ceri o copie a datelor tale</li>
                <li><strong>Dreptul la rectificare</strong> — să corectezi datele inexacte</li>
                <li><strong>Dreptul la ștergere („dreptul de a fi uitat")</strong> — să-ți ștergi contul</li>
                <li><strong>Dreptul la restricționare</strong> — să limitezi prelucrarea</li>
                <li><strong>Dreptul la portabilitate</strong> — să primești datele tale într-un format structurat</li>
                <li><strong>Dreptul la opoziție</strong> — față de prelucrare bazată pe interes legitim</li>
                <li><strong>Dreptul de a depune plângere</strong> la <a href="https://www.dataprotection.ro/" target="_blank" rel="noopener noreferrer">ANSPDCP</a></li>
            </ul>
            <p>
                Trimite cererile la <a href={`mailto:${OPERATOR.email}`}>{OPERATOR.email}</a>. Răspundem în maxim 30 zile.
            </p>

            <h2>7. Securitatea datelor</h2>
            <ul>
                <li>Parole stocate criptat cu bcrypt (ireversibil)</li>
                <li>Transmitere date HTTPS/TLS obligatoriu</li>
                <li>Cookies HTTP-only (nu pot fi citite din JavaScript — protecție XSS)</li>
                <li>Autentificare 2FA disponibilă (TOTP și WhatsApp)</li>
                <li>Rate limiting pe autentificare și înregistrare</li>
                <li>Validare semnătură pe webhook-urile procesatorilor de plăți</li>
                <li>Izolare strictă multi-tenant (un restaurant NU vede datele altuia)</li>
            </ul>

            <h2>8. Cookies</h2>
            <p>
                Folosim cookies strict necesare (autentificare) și cookies de analytics anonimizate
                (Google Analytics 4) pentru a măsura traficul. Nu folosim cookies de marketing sau
                publicitate. Detalii în
                <Link to="/legal/cookies" style={{ color: 'var(--amber)' }}> Politica Cookies</Link>.
            </p>

            <h2>9. Modificări ale acestei politici</h2>
            <p>
                Ne rezervăm dreptul de a actualiza această politică. Modificările majore îți vor fi
                comunicate prin email cu minim 30 zile înainte de intrarea în vigoare.
            </p>

            <h2>10. Contact</h2>
            <p>
                Pentru orice întrebare legată de prelucrarea datelor:
                <br />Email: <a href={`mailto:${OPERATOR.email}`}>{OPERATOR.email}</a>
                <br />Adresă: {OPERATOR.address}
            </p>
        </LegalLayout>
    );
}
